module.exports = __webpack_public_path__ + "images/file_icons_v2/ttf-56df3b646390c4e9ad593e7228ca46d9.svg";